import { Paper } from "@mui/material";
import PairingRecordsChosenHead from "./PairingRecordsChosen/PairingRecordsChosenHead";
import PairingRecordsChosenTable from "./PairingRecordsChosen/PairingRecordsChosenTable";
import PairAddRecords from "./PairingRecordsChosen/PairAddRecords/PairAddRecords";


const tableHeadings = {
  company: "Company",
  date: "Date",
  receipt_number: "Receipt Number",
  receipt_amount: "Receipt Amount",
  receipt_status: "Receipt Status",
  fme: "FME",
  credit: "Credit",
  debit: "Debit",
  covered: "% Covered",
};
const rows = [
  {
  company: "Boyle",
  date: "25/07/25",
  receipt_number: "RC259001039",
  receipt_amount: "174.35",
  receipt_status: "Collected",
  fme: [],
  credit: "180.34",
  debit: "171.37",
  covered: "100%",
  },
  {
  company: "Boyle",
  date: "25/07/25",
  receipt_number: "RC259001039",
  receipt_amount: "174.35",
  receipt_status: "Collected",
  fme: ["5325","5325","5325"],
  credit: "180.34",
  debit: "171.37",
  covered: "103%",
  },
  {
  company: "Boyle",
  date: "25/07/25",
  receipt_number: "RC259001039",
  receipt_amount: "174.35",
  receipt_status: "Collected",
  fme: ["5325", "2039"],
  credit: "180.34",
  debit: "171.37",
  covered: "73%",
  },
 
];

const PairReceipts = () => {
  return (
    <>
      <Paper>
        <PairingRecordsChosenHead />
        <PairingRecordsChosenTable tableHeadings={tableHeadings} rows={rows} />
      </Paper>

      <PairAddRecords/>
    </>
  );
};

export default PairReceipts;
